<template>
  <ContentPage>
    <div class="d-flex flex-column" style="width: 100%">
      <SearchBar v-model="search_filter" class="mt-2"/>

      <FrequentServices 
        v-if="!search_filter && headers.services.length > 0" 
        :services="headers.services"
        :title="headers.list_name"
        @click="serviceClick"
      />

      <div class="pa-2 rounded-lg mt-2" style="background-color: white;">
        <h3>All Recommendation Categories</h3>

        <div v-for="category in filteredCategories" class="d-flex flex-column" :key="category">
          <div class="mt-2 mb-1 pt-2 font-weight-bold">
            {{ category }}
          </div>
          <div class="d-flex flex-row" style="overflow-x: auto">
            <div v-for="service in filteredServices[category]" 
              :key="`s-${service.service_id}`"
              class="d-flex flex-column align-center mr-2"
              @click="serviceClick(service)"
              style="max-width: 192px;"
            >
              <v-img class="rounded elevation-3" v-if="service.service_image_url" max-width="192px"  max-height="108px" :src="service.service_image_url" />
              <div v-else class="rounded grey" style="min-width: 192px; height: 108px;">
              </div>
              <div class="mt-1" style="font-size: 14px;">{{ service.service }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ContentPage>
</template>


<script>

import { ContentPage } from '@/components/pages'
import FrequentServices from './FrequentServices'
import SearchBar from '@/components/SearchBar'

import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'Referrals',
  
  components: { ContentPage, FrequentServices, SearchBar },

  data() {
    return {
      search_filter: '',
    }
  },

  computed: {
    ...mapGetters('services', ['byCategory', 'headers']),

    filteredServices() {
      let results = {}

      const filt = this.search_filter.toLowerCase()

      const sortedCategories =  Object.keys(this.byCategory).sort()
      for(const category of sortedCategories) {
        let services = this.byCategory[category].filter( service => 
          service.service.toLowerCase().includes(filt) ||
          category.toLowerCase().includes(filt)
        )
        if (services.length > 0) {
          results[category] = services
        }
      }
      return results
    },

    filteredCategories() {
      return Object.keys(this.filteredServices)
    },

    hasPreferred() {
      return this.preferred && this.preferred.services.length > 0
    },
  },

  methods: {
    ...mapActions('services', ['loadAll', 'loadHeaders']),
    ...mapActions('referrals', ['setCurrentService']),

    serviceClick(service) {
      this.setCurrentService(service)
      this.$router.push( { name: 'referrals/request' } )
    }
  },

  created() {
    this.loadAll()
    this.loadHeaders()
  },
}

</script>